export default {
    form: {
        necessarily: '(necessarily)'
    },
    placeholders: {
        currentPassword:             'Enter old password...',
        newPassword:                 'Enter new password...',
        createPassword:              'Enter password',
        createPasswordRepeat:        'Repeat password',
        passwordRepeat:              'Confirm new password...',
        chooseManager:               'Choose an HR-manager ...',
        chooseCompany:               'Choose a company ...',
        chooseDepartment:            'Choose department ...',
        chooseLegal:                 'Choose юр. лицо ...',
        chooseLegalDepartment:       'Choose узел оргструктуры ...',
        chooseLegalCell:             'Choose ячейку штатного расписания ...',
        enterPosition:               'Enter position ...',
        enterExplanation:            'Enter explanation ...',
        chooseEmployee:              'Choose employee ...',
        currency:                    'Currency',
        from:                        'From',
        to:                          'To',
        enterTown:                   'Enter city ...',
        quantity:                    '10 for example',
        datepicker:                  'dd/mm/yyyy',
        timepicker:                  'hh:mm',
        enterBonuses:                'Enter the data on bonuses and benefits ...',
        specifyDays:                 'Specify the number of days ...',
        chooseSchedule:              'Choose schedule ...',
        chooseWorkType:              'Choose employment type ...',
        enterExperienceRequirements: 'Enter the necessary requirements for experience ...',
        enterResponsibilities:       'Enter responsibilities ...',
        chooseEducation:             'Choose education ...',
        enterEducationComment:       'Enter education\'s comment ...',
        enterPersonalQualities:      'Enter personal qualities ...',
        chooseLanguage:              'Choose language ...',
        proficiency:                 'Proficiency',
        chooseExperience:            'Choose experience ...',
        enterAdditionalInformation:  'Enter additional information ...',
        comment:                     'Enter comment ...',
        application:                 'Enter application ...',
        shortResult:                 'Short result...',
        freeResult:                  'Enter result in free form...',
        uploadFile:                  'Select file...',
        uploadText:                  'Click or drag file to this area to upload',
        uploadHint:                  'Support for a single file upload. Maximim file size is %(size)sMB.',
        emptyFile:                   'File is not selected',
        clear:                       'Clear',
        inputText:                   'Input name for search (3 letters at least)',
        inputNameText:               'Input person name for search (3 letters at least)',
        personState:                 'Choose state',
        salary:                      'Salary',
        fee:                         'Fee',
        stage:                       'Choose stage ...',
        requestType:                 'Choose request type ...',
        metroPositionCodeApproval:   'If position exists in job catalogue, please load the position data from SAP job catalogue:',
        chooseInterval:              'Choose date interval',
    },
    requestContinueQuestion: {
        question: 'Continue writing request form on vacancy %(position)s?',
        continue: 'Continue',
        new: 'New request',
    },
    rangePicker: {
        today: 'Today',
        thisMonth: 'This month'
    }
};
